export const formatCountries = (countries, countriesFilter) => {
  // filtering countries if filter applied
  const countriesList = countriesFilter ? [...countries.filter(countriesFilter)] : [...countries]

  // Sorting countries in alphabetical order
  return (
    countriesList &&
    countriesList
      .sort((a, b) => {
        if (a.name > b.name) return 1
        if (a.name < b.name) return -1

        return 0
      })
      .map(item => {
        // resourceName is used for Google
        return {
          value: item.id,
          label: item.name,
          code: item.iso2,
          resourceName: item.resource_name,
          tiktok_id: item['tiktok_id']
        }
      })
  )
}
